var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiEmoticonHappyOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_emoticon-happy-outline",
    "data-name": "MDI / emoticon-happy-outline",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_emoticon-happy-outline",
    "data-name": "Path / emoticon-happy-outline",
    d: "M20,12a8,8,0,1,0-8,8,8,8,0,0,0,8-8m2,0A10,10,0,1,1,12,2,10,10,0,0,1,22,12M10,9.5A1.5,1.5,0,1,1,8.5,8,1.538,1.538,0,0,1,10,9.5m7,0A1.5,1.5,0,1,1,15.5,8,1.538,1.538,0,0,1,17,9.5m-5,7.73a5.46,5.46,0,0,1-4.19-1.81L9.23,14A3.267,3.267,0,0,0,12,15.23,3.267,3.267,0,0,0,14.77,14l1.42,1.42A5.46,5.46,0,0,1,12,17.23Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiEmoticonHappyOutline);
export default __webpack_public_path__ + "static/media/MDI - emoticon-happy-outline.88f4f0d7ac253ddf040076395e79849d.svg";
export { ForwardRef as ReactComponent };